import { useState } from "preact/hooks";

import { Form } from "@components/kit/form";
import { PageHeader } from "@components/kit/page-header";
import { Button } from "@components/ui/interactive/button";
import { Container } from "@components/ui/structure/container";
import { Table } from "@components/ui/structure/table";
import { Heading } from "@components/ui/text/heading";
import { LoadingView } from "@components/view/loading-view";
import { useUserManagement } from "@contexts/user-management";
import { useClasses } from "@styles";

export function UserManagementView() {
  const {
    ready,
    activatedUsers,
    whitelistUsers,
    whitelist,
    addInviteExpiry,
    cancelInvite,
    forceLogOut,
  } = useUserManagement();

  const [username, setUsername] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  if (!ready)
    return <LoadingView />

  return (<>
    <Container className={useClasses("um-content")}>
      <PageHeader
        icon="UserRegular"
        title="User Management"
      />

      <Container className={useClasses("um-layouts")}>
        <Container className={useClasses("um-layout")}>
          <Form
            fields={[
              {
                label: "Username",
                type: "text",
                value: username,
                updateValue: (value) => setUsername(value),
              },
              {
                label: "Phone Number",
                type: "tel",
                value: phoneNumber,
                updateValue: (value) => setPhoneNumber(value),
              },
            ]}
          />

          <Button
            icon="UserBadgeCheckRegular"
            title="Assign Role"
            hoverText="Add Role To User"
            disabled={!username || !phoneNumber}
            onClick={() => whitelist(username, phoneNumber)}
          />
        </Container>
      </Container>

      <Container className={useClasses("um-section")}>
        <Heading size="large">Activated Users</Heading>
        <Table
          headers={["Username", "Phone Number", "Actions"]}

          content={Object.values(activatedUsers).map(user => [
            user.username || "-",
            user.phoneNumber || "-",
            <Container className={useClasses("um-actions")}>
              <Button
                icon="LogOutRegular"
                title="Force Log Out"
                hoverText=""
                onClick={() => forceLogOut(user.username || "")}
              />
            </Container>
          ])}
        />
      </Container>

      <Container className={useClasses("um-section")}>
        <Heading size="large">Whitelisted Users</Heading>
        <Table
          headers={["Username", "Phone Number", "Expiry", "Actions"]}

          content={Object.values(whitelistUsers).map(user => [
            user.username || "-",
            user.phoneNumber || "-",
            user.expiry ? (
              new Date(user.expiry * 1000) < new Date()
                ? "Expired"
                : new Date(user.expiry * 1000).toLocaleString()
            ) : "-",
            <Container className={useClasses("um-actions")}>
              <Button
                icon="UserXmarkRegular"
                title="Cancel Invite"
                hoverText=""

                onClick={() => cancelInvite(
                  user.username || "",
                  user.phoneNumber || "",
                )}
              />

              <Button
                icon="UserXmarkRegular"
                title="Extend Expiry to 3 Days"
                hoverText=""

                onClick={() => addInviteExpiry(
                  user.username || "",
                  user.phoneNumber || "",
                  259200,
                )}
              />
            </Container>
          ])}
        />
      </Container>
    </Container>
  </>);
}

